import { useStore } from "@nanostores/react";
import { $organizationList } from "@vega-api/custom/stores/organisations.store";

import { SelectOrganisation } from "./SelectOrganisation";

export const OrganisationNode = () => {
  const organisations = useStore($organizationList);

  const hasOrgOptions = Boolean(organisations.length > 1);

  return hasOrgOptions ? <SelectOrganisation /> : null;
};
